export default __webpack_public_path__ + "static/cafeterabg1_2-30858b6f190dc0d3efb80e3fc6db5ace.png";